module.exports = __webpack_public_path__ + "static/fonts/FaktSoftPro-Blond.e1c87dea.woff2";